import React, {useEffect, useState} from 'react';
import Count from '../common/count';
import {getCMSAssets} from "../../utils/cms.utils";

const Certification = () => {
    const [assets, setAssets] = useState(null);

    useEffect(() => {
        setAssets(getCMSAssets());
    }, []);

    return (
        <>
            <div className="certification section-padding pt-0">
                <div className="container pt-5">
                    <div className="row">
                        <div className="col-xl-4 col-lg-5 lg-mb-25">
                            <div className="certification-left section-padding pb-0">
                                <span className="subtitle wow fadeInLeft"
                                      data-wow-delay=".4s">Corporate Certifications</span>
                                <h2 className="title_split_anim">Our Key Achievements Over the Years</h2>
                                <h5 className="title_split_anim">Pencapaian Utama Kami Selama Bertahun-tahun</h5>
                            </div>
                        </div>
                        <div className="col-xl-8 col-lg-7">
                            <div className="certification-right">
                                <img className="wow img_top_animation" src={assets?.corp_certification} alt="image"
                                     style={{borderRadius: '20px'}}/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="counter__one-area mt-80">
                                <div className="certification-right-counter">
                                    <h2><Count number={500}/>+</h2>
                                    <p>Complete Projects</p>
                                </div>
                                <div className="certification-right-counter">
                                    <h2><Count number={100}/>+</h2>
                                    <p>Team Members</p>
                                </div>
                                <div className="certification-right-counter">
                                    <h2><Count number={500}/>+</h2>
                                    <p>Client Reviews</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Certification;